/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { a as t } from "../../../../chunks/vec2f64.js";
import { t as n } from "../../../../chunks/vec4.js";
import { c as r } from "../../../../chunks/vec4f64.js";
const o = r();
class e {
  constructor(t) {
    this.message = t;
  }
  toString() {
    return `AssertException: ${this.message}`;
  }
}
function s(t, n) {
  if (!t) {
    n = n || "Assertion";
    const t = new Error(n).stack;
    throw new e(`${n} at ${t}`);
  }
}
function c(t, n) {
  t || (n = n || "", console.warn("Verify failed: " + n + "\n" + new Error("verify").stack));
}
function i(t, n, r, o) {
  let e,
    s = (r[0] - t[0]) / n[0],
    c = (o[0] - t[0]) / n[0];
  s > c && (e = s, s = c, c = e);
  let i = (r[1] - t[1]) / n[1],
    f = (o[1] - t[1]) / n[1];
  if (i > f && (e = i, i = f, f = e), s > f || i > c) return !1;
  i > s && (s = i), f < c && (c = f);
  let u = (r[2] - t[2]) / n[2],
    a = (o[2] - t[2]) / n[2];
  return u > a && (e = u, u = a, a = e), !(s > a || u > c) && (a < c && (c = a), !(c < 0));
}
function f(n, r, o, e, s, c = t()) {
  const i = (e[s] - o[s]) * (r[0] - n[0]) - (e[0] - o[0]) * (r[s] - n[s]),
    f = (e[0] - o[0]) * (n[s] - o[s]) - (e[s] - o[s]) * (n[0] - o[0]);
  if (0 === i) return !1;
  const u = f / i;
  return c[0] = n[0] + u * (r[0] - n[0]), c[1] = n[s] + u * (r[s] - n[s]), !0;
}
function u(t, r, e, c, i) {
  o[0] = t[0], o[1] = t[1], o[2] = t[2], o[3] = 1, n(o, o, r), i.length > 2 && (i[2] = -o[2]), n(o, o, e), s(0 !== o[3]), i[0] = o[0] / o[3], i[1] = o[1] / o[3], i[2] = o[2] / o[3], i[0] = (.5 * i[0] + .5) * c[2] + c[0], i[1] = (.5 * i[1] + .5) * c[3] + c[1];
}
function a(t, n) {
  return Math.log(t) / Math.log(n);
}
function h(t, n, r, o) {
  t[12] = n, t[13] = r, t[14] = o;
}
function l(t) {
  return 1 === t[0] && 0 === t[1] && 0 === t[2] && 0 === t[3] && 0 === t[4] && 1 === t[5] && 0 === t[6] && 0 === t[7] && 0 === t[8] && 0 === t[9] && 1 === t[10] && 0 === t[11] && 1 === t[15];
}
export { s as assert, l as isTranslationMatrix, a as logWithBase, u as project, i as rayBoxTest, f as rayRay2D, h as setMatrixTranslation3, c as verify };